import { args as clientArgs, Client as ClientLite } from '@neo-one/client-core';
import * as args from './args';
import { ReadClient } from './ReadClient';
export class Client extends ClientLite {
    async publish(contract, optionsIn) {
        const options = clientArgs.assertTransactionOptions('options', optionsIn);
        await this.applyBeforeRelayHook(options);
        return this.addTransactionHooks(this.getProvider(options).publish(args.assertContractRegister('contract', contract), options));
    }
    async publishAndDeploy(contract, abi, params = [], optionsIn, sourceMaps = {}) {
        const options = clientArgs.assertTransactionOptions('options', optionsIn);
        await this.applyBeforeRelayHook(options);
        return this.addTransactionHooks(this.getProvider(options).publishAndDeploy(args.assertContractRegister('contract', contract), clientArgs.assertABI('abi', abi), params, options, sourceMaps));
    }
    async registerAsset(asset, optionsIn) {
        const options = clientArgs.assertTransactionOptions('options', optionsIn);
        await this.applyBeforeRelayHook(options);
        return this.addTransactionHooks(this.getProvider(options).registerAsset(args.assertAssetRegister('asset', asset), options));
    }
    async issue(...argsIn) {
        const { transfers, options } = this.getTransfersOptions(argsIn);
        await this.applyBeforeRelayHook(options);
        return this.addTransactionHooks(this.getProvider(options).issue(transfers, options));
    }
    read(network) {
        return new ReadClient(this.getNetworkProvider(clientArgs.assertString('network', network)).read(clientArgs.assertString('network', network)));
    }
}

//# sourceMappingURL=Client.js.map
